<ion-accordion-group #accordionGroup>
  <ion-accordion value="firstRow">
    <ion-item id="no-ripple" class="gray-content-bg" slot="header">
      <div class="expandable-section">
        <div class="title">
          <h1
            *ngIf="orderExceptionType !== exceptionType.DATE"
            data-cy="exception-section-title"
          >
            {{ sectionTitle }}<span>({{ exceptionResolutions?.length }})</span>
          </h1>
          <h1
            *ngIf="orderExceptionType === exceptionType.DATE"
            data-cy="exception-section-date-title"
          >
            {{ sectionTitle }}<span>(1)</span>
          </h1>
          <div class="alert-message" data-cy="exception-section-message-text">
            {{ exceptionMessage }}
          </div>
        </div>
        <ion-button
          class="usf-fill-green-button"
          *ngIf="orderExceptionType === exceptionType.ACKNOWLEDGEMENT"
          disabled="{{ !isExpanded }}"
          (click)="confirmAll()"
          data-cy="confirm-all-exception-section-button"
          >{{ 'i18n.orderExceptionsPage.confirmAll' | translate }}</ion-button
        >
        <div
          *ngIf="
            orderExceptionType === exceptionType.DATE &&
            exceptionResolutions[0].dateCompleted
          "
          class="completed-text"
          data-cy="exception-section-completed-text"
        >
          Completed
        </div>
      </div>
    </ion-item>
    <div class="gray-content-bg add-padding" slot="content" tabindex="0">
      <ng-container
        *ngFor="
          let exceptionResolution of exceptionResolutions;
          trackBy: trackByIndex;
          first as highestPriority
        "
      >
        <div
          class="wrapper"
          [ngClass]="isExpanded ? 'add-border' : 'remove-border'"
        >
          <app-acknowledgement-row-tablet
            *ngIf="orderExceptionType === exceptionType.ACKNOWLEDGEMENT"
            [exceptionResolution]="exceptionResolution"
            [product]="
              productMap.get(exceptionResolution.orderException.productNumber)
            "
            [orderNumber]="orderHeader.tandemOrderNumber"
            (exceptionResolved)="resolveExceptionHandler($event)"
          >
          </app-acknowledgement-row-tablet>
          <app-substitution-row-tablet
            *ngIf="
              orderExceptionType === exceptionType.OUT_OF_STOCK ||
              orderExceptionType === exceptionType.PRODUCT_UNAVAILABLE ||
              orderExceptionType === exceptionType.RESTRICTED
            "
            [exceptionResolution]="exceptionResolution"
            [exceptionType]="orderExceptionType"
            [productMap]="productMap"
            [searchForSubsMap]="searchForSubsMap"
            [platformEnum]="platformEnum"
            [masterListRestricted]="masterListRestricted"
            [hideSearchForSubs]="hideSearchForSubs"
            [isPartialExceptionsFlagEnabled]="isPartialExceptionsFlagEnabled"
            (searchForSubsClicked)="searchForSubsHandler($event)"
            (exceptionResolved)="resolveExceptionHandler($event)"
            (partialFlagResolved)="partialFlagResolveHandler($event)"
            (substituteProductFlipped)="flipSubstituteProduct($event)"
            (editRowResolved)="editRowHandler($event)"
            (cancelEditRow)="cancelEditRowHandler($event)"
            (compareProductsClicked)="
              compareProductsHandler(exceptionResolution)
            "
          ></app-substitution-row-tablet>
          <app-unusual-quantity-row-tablet
            *ngIf="orderExceptionType === exceptionType.UNUSUAL_QUANTITY"
            [exceptionResolution]="exceptionResolution"
            [exceptionType]="orderExceptionType"
            [product]="
              productMap.get(exceptionResolution.orderException.productNumber)
            "
            (exceptionResolved)="resolveExceptionHandler($event)"
          ></app-unusual-quantity-row-tablet>
          <app-pricing-row-tablet
            *ngIf="orderExceptionType === exceptionType.PRICE"
            [exceptionType]="orderExceptionType"
            [exceptionResolution]="exceptionResolution"
            [product]="
              productMap.get(exceptionResolution.orderException.productNumber)
            "
            [sellerPrice]="sellerPrice"
            (exceptionResolved)="resolveExceptionHandler($event)"
            (updatePriceEmitter)="updatePriceHandler($event)"
          >
          </app-pricing-row-tablet>
          <app-date-row-tablet
            *ngIf="orderExceptionType === exceptionType.DATE && highestPriority"
            [exceptionResolution]="exceptionResolution"
            [orderHeader]="orderHeader"
            [selectedDate]="selectedDate"
            (exceptionResolved)="resolveExceptionHandler($event)"
            (updateDateEmitter)="updateDateHandler($event)"
          >
          </app-date-row-tablet>
        </div>
      </ng-container>
    </div>
  </ion-accordion>
</ion-accordion-group>
